module.exports = __webpack_public_path__ + "files/a47d15cb52d9dbd3a9309743ea86ef4b.png";